<template>
    <div>
        <b-form-group
            id="fieldset-users"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            label-for="sendNotification"
            :description="$t('settings.teams.users.description')"
            :label="$t('settings.teams.users.label')"
        >
            <v-select id="users-select" v-model="teamData.users" label="name" multiple :options="users" />
        </b-form-group>

        <hr />
    </div>
</template>
<script>
import vSelect from "vue-select";
import { BFormGroup } from "bootstrap-vue";

export default {
    components: {
        vSelect,
        BFormGroup,
    },
    props: {
        teamData: {
            type: Object,
            required: true,
        },
        users: {
            type: Array,
            required: true,
        },
    },
};
</script>
